import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterSeaPoint() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-sea-point",
    name: "Painters Sea Point",
    location: "Sea Point, Cape Town",
    rating: 4.9,
    reviews: 187,
    specialties: ["Coastal Painting", "Apartment Painting", "Weather Protection", "Luxury Finishes"],
    image: "https://public.readdy.ai/ai/img_res/d592f1de586529578cfad44c5d02b316.jpg",
    verified: true,
    yearsExperience: 17,
    website: "http://paintersseapoint.co.za/",
    email: "info@paintersseapoint.co.za",
    description: "Painters Sea Point is your premier painting contractor serving Sea Point and the Atlantic Seaboard. With over 17 years of experience in coastal painting, we specialize in apartment complexes, luxury homes, and commercial properties. Our team understands the unique challenges of painting in coastal environments and uses marine-grade materials that withstand salt air, strong winds, and intense UV exposure. From high-rise apartments to beachfront properties, we deliver exceptional results that protect and beautify your investment.",
    services: [
      "Apartment Complex Painting",
      "Luxury Home Painting",
      "Coastal Property Protection",
      "Interior Painting Services",
      "Exterior Painting & Coating",
      "Waterproofing Solutions",
      "Balcony & Deck Restoration",
      "Marine-Grade Finishes",
      "Color Consultation",
      "Emergency Repairs"
    ],
    serviceAreas: ["Sea Point", "Bantry Bay", "Fresnaye", "Three Anchor Bay", "Green Point", "Mouille Point", "Clifton"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20luxury%20apartment%20interior%20painted%20by%20professional%20painters%20in%20Sea%20Point%20Cape%20Town%2C%20modern%20coastal%20living%20room%20with%20ocean%20views%2C%20fresh%20white%20walls%20with%20premium%20paint%20finish%2C%20elegant%20furniture%2C%20bright%20natural%20lighting%2C%20high-end%20residential%20painting%20work&width=400&height=300&seq=seapoint-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20apartment%20building%20painting%20project%20in%20Sea%20Point%20Cape%20Town%2C%20Atlantic%20Seaboard%20high-rise%20with%20fresh%20paint%2C%20professional%20painters%20working%20on%20coastal%20property%2C%20quality%20exterior%20finish%2C%20ocean%20backdrop%2C%20well-maintained%20building&width=400&height=300&seq=seapoint-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Luxury%20beachfront%20home%20painting%20in%20Sea%20Point%20Cape%20Town%2C%20professional%20painters%20working%20on%20premium%20coastal%20property%20exterior%2C%20marine-grade%20paint%20application%2C%20modern%20architecture%20with%20ocean%20views%2C%20organized%20professional%20work%20site&width=400&height=300&seq=seapoint-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Modern%20kitchen%20interior%20painting%20in%20Sea%20Point%20luxury%20apartment%2C%20fresh%20painted%20walls%20with%20premium%20finish%2C%20contemporary%20design%2C%20ocean%20view%20through%20windows%2C%20bright%20clean%20space%2C%20professional%20quality%20painting%20work&width=400&height=300&seq=seapoint-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Balcony%20restoration%20and%20painting%20in%20Sea%20Point%20apartment%2C%20professional%20coastal%20painting%20work%2C%20marine-grade%20protective%20coating%2C%20Atlantic%20Ocean%20views%2C%20quality%20finish%20on%20outdoor%20surfaces&width=400&height=300&seq=seapoint-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Commercial%20property%20exterior%20painting%20in%20Sea%20Point%20Cape%20Town%2C%20professional%20painters%20working%20on%20retail%20building%2C%20quality%20commercial%20paint%20finish%2C%20Atlantic%20Seaboard%20location%2C%20modern%20architecture&width=400&height=300&seq=seapoint-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Michael Roberts",
        rating: 5,
        comment: "Outstanding work on our Sea Point apartment complex. The team handled the challenging coastal conditions expertly and the building looks fantastic. Professional service from start to finish."
      },
      {
        name: "Jennifer Adams", 
        rating: 5,
        comment: "Highly recommend Painters Sea Point for any coastal property. They painted our beachfront home and used specialized materials that have held up perfectly against the salt air. Excellent quality and attention to detail."
      },
      {
        name: "David Chen",
        rating: 5,
        comment: "Professional team that understands luxury finishes. They transformed our Sea Point penthouse with beautiful results. Clean workers, on schedule, and the quality is exceptional."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Sea Point | Professional Painting Services Cape Town | Coastal Apartment Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Sea Point offers professional painting services for coastal properties in Sea Point, Cape Town. Specializing in apartments, luxury homes, and marine-grade finishes. 17+ years experience. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Sea Point, apartment painters Sea Point, painting contractors Cape Town, coastal property painting, luxury painting services');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20luxury%20apartment%20building%20in%20Sea%20Point%20Cape%20Town%2C%20stunning%20Atlantic%20Ocean%20coastline%20views%20with%20dramatic%20waves%2C%20painters%20in%20clean%20uniforms%20with%20premium%20equipment%2C%20modern%20high-rise%20architecture%20with%20ocean%20backdrop%2C%20bright%20natural%20lighting%2C%20high%20quality%20coastal%20painting%20project&width=1200&height=600&seq=seapoint-painters-hero-main&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Sea Point</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Coastal Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Sea Point's prime Atlantic Seaboard location presents unique painting challenges. The constant exposure to salt spray, ocean winds, and intense UV radiation requires specialized expertise and premium materials. Our team has over 17 years of experience working specifically in coastal environments, making us the ideal choice for your Sea Point painting project. We understand how to properly prepare surfaces, select appropriate materials, and apply coatings that will withstand the harsh marine environment.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Apartment Complex Expertise</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Sea Point is home to numerous apartment complexes and high-rise buildings, each with unique painting requirements. We specialize in large-scale residential projects, coordinating with body corporates and managing complex logistics to minimize disruption to residents. Our experience includes everything from small apartment blocks to major high-rise renovations, always delivered with professionalism and attention to detail.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Marine-Grade Materials</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  We exclusively use premium paints and coatings specifically formulated for coastal environments. These specialized products offer superior resistance to salt corrosion, UV fading, moisture penetration, and mildew growth. Our material selection includes leading international brands known for their performance in marine environments, ensuring your investment is protected for years to come.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Luxury Finishes</h3>
                <p className="text-gray-700 leading-relaxed mb-8">
                  Sea Point's premium properties demand exceptional finishes. Our team is experienced in delivering luxury results, from designer color schemes to specialty finishes and decorative techniques. We work closely with interior designers, architects, and property owners to achieve the perfect aesthetic while maintaining the durability required for coastal living.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20luxury%20apartment%20in%20Sea%20Point%20Cape%20Town%2C%20Atlantic%20Ocean%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20modern%20coastal%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=seapoint-sidebar-image&orientation=landscape"
                      alt="Professional painters Sea Point luxury apartment painting services Cape Town Atlantic Seaboard"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Sea Point</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Residential & Commercial Painting</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for the unique challenges of Sea Point's coastal environment. From luxury apartments to commercial properties, we provide comprehensive solutions that protect and beautify your property while withstanding the harsh Atlantic Seaboard conditions.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} with marine-grade materials and expert coastal application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Transform your Sea Point property with our professional interior painting services. We use premium, low-VOC paints that are safe for your family while providing excellent coverage and durability. Our color consultation services help you choose the perfect palette that complements your coastal lifestyle and maximizes natural light from those stunning ocean views.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the importance of minimizing disruption in apartment living. Our team works efficiently and cleanly, respecting your space and schedule. We can work room by room or coordinate with building management for larger projects.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Protection</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Sea Point requires specialized knowledge of coastal conditions. We use marine-grade paints and protective coatings that resist salt corrosion, UV damage, and moisture penetration. Our comprehensive exterior painting process includes thorough surface preparation, primer application, and multiple coats of premium paint for maximum protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also offer specialized services such as balcony restoration, waterproofing, and protective coatings for metal fixtures. These additional services ensure complete protection for your coastal property investment.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Sea Point</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Sea Point and the Atlantic Seaboard. Each project demonstrates our commitment to quality workmanship and our expertise in coastal painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Sea Point Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional coastal painting with marine-grade materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Sea Point have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from homeowners and property managers in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Sea Point</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Sea Point property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that enhance your coastal lifestyle.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and Atlantic Seaboard</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Sea Point painting project. Our experienced team will assess your property and provide detailed recommendations tailored to coastal conditions.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
